import React, { useState } from 'react';
import Select, {
  GroupBase,
  Props as SelectProps,
  SelectInstance,
} from 'react-select';
import AsyncSelect from 'react-select/async';
import { SelectorDefaultStyles } from './SelectorDefaultStyles';

type Props = {
  indicator?: string;
  isError?: boolean;
  isDatePickerSelector?: boolean;
  isSelectorWithChips?: boolean;
  searchValue?: string;
  handleSearchChange?: (searchValue: string) => void;
} & SelectProps;

export type CustomSelectInstanceType = SelectInstance<
  unknown,
  boolean,
  GroupBase<unknown>
>;

export const CustomSelector = React.forwardRef<CustomSelectInstanceType, Props>(
  (
    {
      styles,
      isError,
      isDatePickerSelector,
      isSelectorWithChips,
      indicator,
      searchValue,
      handleSearchChange,
      ...props
    },
    ref,
  ) => {
    return (
      <Select
        ref={ref}
        inputValue={searchValue}
        onInputChange={handleSearchChange}
        styles={{
          ...SelectorDefaultStyles(
            isError,
            isDatePickerSelector,
            isSelectorWithChips,
            indicator,
          ),
          ...styles,
        }}
        {...props}
      />
    );
  },
);

export const CustomAsyncSelector = ({ styles, ...props }: Props) => {
  return (
    <AsyncSelect styles={{ ...SelectorDefaultStyles, ...styles }} {...props} />
  );
};
